<template>
<!--    用戶審批-->
    <div>
        <vs-row vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span :class="isMobile() ? 'titleMob' : 'title'">{{$t('message.approvalUser')}}</span>
            </vs-col>

        </vs-row>
        <vs-table :data="user" stripe pagination maxItems="15">
            <template slot="thead">
                <vs-th>
                    {{$t('message.username')}}
                </vs-th>
                <vs-th>
                    {{$t('message.email')}}
                </vs-th>
                <vs-th>
                    {{$t('message.phone')}}
                </vs-th>
                <vs-th>
                    {{$t('message.role')}}
                </vs-th>
                <vs-th>
                    {{$t('message.createdAt')}}
                </vs-th>
                <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].username">
                        {{data[indextr].username}}
                    </vs-td>
                    <vs-td :data="data[indextr].email">
                        {{data[indextr].email}}
                    </vs-td>

                    <vs-td :data="data[indextr].phone">
                        {{data[indextr].phone}}
                    </vs-td>
                    <vs-td :data="data[indextr].role">
                        <span class="tags Bg1" v-if="tr.role == 'admin'">Admin</span>
                        <span class="tags Bg2" v-if="tr.role == 'agent'">Agent</span>
                        <span class="tags Bg3" v-if="tr.role == 'manager'">Manager</span>
                        <span class="tags Bg4" v-if="tr.role == 'user'">User</span>
                    </vs-td>
                    <vs-td :data="data[indextr].createdAt">
                        {{data[indextr].createdAt | dateFormat}}
                    </vs-td>
                    <vs-td>
                        <vs-button size="small" @click="editUser(tr)" style="margin-right: 10px">{{$t('message.edit')}}</vs-button>
                        <vs-button size="small" type="border" color="danger" @click="onApproval(tr._id)" v-role="['admin']">{{$t('message.pendingApproval')}}</vs-button>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-popup :active.sync="updateFlag" title=" ">
            <div class="card-title">
                {{$t('message.updateUser')}}
            </div>
            <vs-row class="m-t-1">
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.username" :placeholder="$t('message.username')"  style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.password" type="password" :placeholder="$t('message.password')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-1">
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.name" :placeholder="$t('message.name')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.agentNumber" :placeholder="$t('message.agentNumber')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-1">
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.email" :placeholder="$t('message.email')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.phone" :placeholder="$t('message.phone')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-3">
                <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                    <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn m-t-1" @click="onUpdateUser()">{{$t('message.update')}}</vs-button>
                    <vs-button size="small" color="danger" class="stribtn" @click="onDeleteUser()">{{$t('message.delete')}}</vs-button>

                </vs-col>
            </vs-row>
        </vs-popup>

        <vs-popup :active.sync="updateCustomerFlag" title=" ">
            <div class="card-title">
                {{$t('message.updateUser')}}
            </div>
            <vs-row class="m-t-1">
                <vs-col vs-w="6">
                    <vs-select v-model="customer.agent" autocomplete :placeholder="$t('message.agent')" style="width: 100%">
                        <vs-select-item :key="index" :value="item._id" :text="`${item.name} (${item.agentNumber})`" v-for="(item,index) in agent" />
                    </vs-select>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.username" :placeholder="$t('message.username')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-1">
                <vs-col vs-w="6">
                    <vs-input v-model="customer.name" :placeholder="$t('message.name')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.code" :placeholder="$t('message.customerCode')+' (e.g. C0000001)'" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-1">
                <vs-col vs-w="6">
                    <vs-select v-model="customer.gender" autocomplete :placeholder="$t('message.gender')" style="width: 100%">
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in genderOpt" />
                    </vs-select>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.phone" :placeholder="$t('message.phone')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-1">
                <vs-col vs-w="6">
                    <vs-input v-model="customer.email" :placeholder="$t('message.email')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <datepicker class="fixedPicker" v-model="customer.dateOfBirth" :placeholder="$t('message.dateOfBirth')" :format="format"
                                :highlighted="highlight"></datepicker>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-1">
                <vs-col vs-w="6">
                    <vs-input v-model="customer.residenceAddress" :placeholder="$t('message.residentialAddress')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.correspondenceAddress" :placeholder="$t('message.corrAddress')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-3">
                <vs-col vs-w="12" vs-type="flex" vs-align="center">
                    <span style="font-size: 18px;margin-right: 15px;color: #626262">{{$t('message.plan')}}</span>
                    <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="handleMethods('addPlan')">+ {{$t('message.plan')}}</vs-button>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-1">
                <vs-col vs-w="12" style="width: 100%" v-if="customer.plans[0]" class="scrollTable">
                    <vs-table :data="customer.plans" stripe noDataText="No Plan" style="overflow: scroll">
                        <template slot="thead">
                            <vs-th></vs-th>
                            <vs-th>
                                <span style="color:#959595">{{$t('message.subscriptedPlan')}}</span>
                            </vs-th>
                            <vs-th>
                                {{$t('message.currency')}}
                            </vs-th>
                            <vs-th>
                                {{$t('message.validDate')}}
                            </vs-th>
                            <vs-th>
                                {{$t('message.expiryDate')}}
                            </vs-th>
                            <vs-th>
                                {{$t('message.balanceAmount')}}
                            </vs-th>
                            <vs-th>
                                {{$t('message.expectedAnnualReturn')}}
                            </vs-th>
                            <vs-th>
                                {{$t('message.actualAnnualReturn')}}
                            </vs-th>
                            <vs-th>
                                {{$t('message.beneficiary')}}
                            </vs-th>
                            <vs-th>
                                {{$t('message.beneficiaryDeath')}}
                            </vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td>
                                    <vs-button size="small" color="danger" type="border" icon="remove" @click="customer.plans.splice(indextr,1)"></vs-button>
                                </vs-td>
                                <vs-td :data="data[indextr].name">
                                    <span style="color: #909090">{{lang == 'en' ? data[indextr].name : data[indextr].name_zh}}</span>
                                </vs-td>

                                <vs-td :data="data[indextr].currency">
                                    {{data[indextr].currency}}
                                </vs-td>

                                <vs-td :data="data[indextr].effectiveDate">
                                    {{data[indextr].effectiveDate | dateFormat}}
                                </vs-td>
                                <vs-td :data="data[indextr].expiryDate">
                                    {{data[indextr].expiryDate | dateFormat}}
                                </vs-td>
                                <vs-td :data="data[indextr].amount">
                                    {{data[indextr].amount}}
                                </vs-td>
                                <vs-td :data="data[indextr].expectedAnnualReturn">
                                    {{data[indextr].expectedAnnualReturn}}
                                </vs-td>
                                <vs-td :data="data[indextr].actualAnnualReturn">
                                    {{data[indextr].actualAnnualReturn}}
                                </vs-td>
                                <vs-td :data="data[indextr].beneficiaries">
                                    <div v-if="tr.beneficiaries && tr.beneficiaries[0]">
                                        {{data[indextr].beneficiaries.join(', ').tran()}}
                                    </div>
                                    <div v-else>
                                        {{data[indextr].beneficiary.tran()}}
                                    </div>
                                </vs-td>
                                <vs-td :data="data[indextr].beneficiariesAfterDeath">
                                    <div v-if="tr.beneficiariesAfterDeath && tr.beneficiariesAfterDeath[0]">
                                        {{data[indextr].beneficiariesAfterDeath.join(', ').tran()}}
                                    </div>
                                    <div v-else>
                                        {{data[indextr].beneficiaryAfterDeath.tran()}}
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-col>
                <vs-col vs-w="12" v-else>
                    <textarea name="plan" id="plan" disabled></textarea>
                </vs-col>
            </vs-row>
            <vs-row style="margin-top: 20px">
                <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                    <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn m-r-1" @click="onUpdateCustomer()">{{$t('message.update')}}</vs-button>
                    <vs-button size="small" color="danger" class="stribtn" @click="onDeleteCustomer()">{{$t('message.delete')}}</vs-button>
                </vs-col>
            </vs-row>

            <vs-popup :active.sync="addPlanFlag" title=" ">
                <EditPlan type="add" :data.sync="newPlan" @add="addPlan" :uploading.sync="uploading" @upload="uploadDocs" />
            </vs-popup>
        </vs-popup>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import EditPlan from "@/components/EditPlan";
    export default {
        data(){
            return{
                token:'',
                lang:'',
                format: 'dd / MM / yyyy',
                highlight: {
                    customPredictor(date) {
                        if ((date.getDate() - new Date().getDate() == 0) && (date.getMonth() - new Date().getMonth() == 0))
                            return true;
                    }
                },
                user:[],
                agent:[],
                updateFlag:false,
                updateCustomerFlag:false,
                currentUser:{
                    username:'',
                    password:'',
                    name:'',
                    phone:'',
                    email:'',
                    agentNumber:''
                },
                customer:{
                    agent:'',
                    username:'',
                    password:'',
                    name:'',
                    email:'',
                    phone:'',
                    code:'',
                    gender:'',
                    dateOfBirth:'',
                    residenceAddress:'',
                    correspondenceAddress:'',
                    plans:[]
                },
                genderOpt:[
                    {value:'male',text:this.$t('message.male')},
                    {value:'female',text:this.$t('message.female')},
                ],
                plan:{
                    name:'',
                    name_zh:'',
                    currency:'USD',
                    effectiveDate:'',
                    expiryDate:'',
                    amount:'',
                    expectedAnnualReturn:'',
                    actualAnnualReturn:'',
                    beneficiaries:[],
                    beneficiariesAfterDeath:[],
                    totalNetContributionSinceEffectiveDate:'',
                    totalTransferAsset:'',
                    totalTransferOutAsset:'',
                    investmentBalanceSinceEffectiveDate:'',
                    balance:'',
                    return:'',
                    quarterlyFundOverview:'',
                    dividendMode: '',
                },
                addPlanFlag:false,
                newPlan:{
                    name:'',
                    name_zh:'',
                    currency:'USD',
                    effectiveDate:'',
                    expiryDate:'',
                    amount:'',
                    expectedAnnualReturn:'',
                    actualAnnualReturn:'',
                    beneficiaries:[],
                    beneficiariesAfterDeath:[],
                    totalNetContributionSinceEffectiveDate:'',
                    totalTransferAsset:'',
                    totalTransferOutAsset:'',
                    investmentBalanceSinceEffectiveDate:'',
                    balance:'',
                    return:'',
                    quarterlyFundOverview:'',
                    dividendMode: '',
                },
                uploading:false,
            }
        },
        created() {
            this.token = this.$cookies.get('token');
            this.lang = this.$cookies.get('lang');
            let obj = {
                status:'under_approval',
                role:this.$cookies.get('role') == 'admin' ? ['admin','manager','agent','user'] : ['agent','user'],
                access_token:this.$cookies.get('token')
            }
            this.$vs.loading({
                type:'point'
            })
            let url = process.env.VUE_APP_API_BASEURL + '/api/user?' + this.$qs.stringify(obj,{arrayFormat: 'brackets'})
            fetch(url).then((response)=>{
                return response.json()
            }).then((result)=>{
                this.user = result.responseDetail.data;
                if(result){
                    this.$vs.loading.close()
                }
            })

            let aurl = process.env.VUE_APP_API_BASEURL + '/api/user?role[]=agent&status=normal&access_token=' + this.$cookies.get('token');
            fetch(aurl).then((response)=>{
                return response.json()
            }).then((data)=>{
                this.agent = data.responseDetail.data;
            })
        },
        methods:{
            onReload(){
                let obj = {
                    status:'under_approval',
                    role:this.$cookies.get('role') == 'admin' ? ['admin','manager','agent','user'] : ['agent','user'],
                    access_token:this.$cookies.get('token')
                }
                this.$vs.loading({
                    type:'point'
                })
                let url = process.env.VUE_APP_API_BASEURL + '/api/user?' + this.$qs.stringify(obj,{arrayFormat: 'brackets'})
                fetch(url).then((response)=>{
                    return response.json()
                }).then((result)=>{
                    this.user = result.responseDetail.data;
                    if(result){
                        this.$vs.loading.close()
                    }
                })
            },
            handleMethods(type){
                switch (type){
                    case "addPlan":{
                        this.newPlan = {
                            name: '',
                            name_zh: '',
                            currency: 'HKD',
                            effectiveDate:'',
                            expiryDate:'',
                            amount:'',
                            expectedAnnualReturn: '',
                            actualAnnualReturn:'',
                            beneficiaries:[],
                            beneficiariesAfterDeath:[],
                            totalNetContributionSinceEffectiveDate:'',
                            totalTransferAsset:'',
                            totalTransferOutAsset:'',
                            investmentBalanceSinceEffectiveDate:'',
                            balance:'',
                            return:'',
                            quarterlyFundOverview:'',
                            dividendMode: '',
                            planTemplate: ''
                        }
                        this.addPlanFlag = true;
                        break;
                    }
                }
            },
            editUser(item){
                this.currentUser = {}
                switch (item.role) {
                    case 'user':
                        let purl = process.env.VUE_APP_API_BASEURL + '/api/customer/' + item.customer[0]._id + '?access_token=' + this.token;
                        fetch(purl).then((response) =>{
                            return response.json()
                        }).then((result)=>{
                            this.customer = {
                                _id:result.responseDetail._id,
                                agent:result.responseDetail.agent ? result.responseDetail.agent._id : '',
                                username:result.responseDetail.user.username,
                                password:'',
                                name:result.responseDetail.user.name,
                                email:result.responseDetail.user.email,
                                phone:result.responseDetail.user.phone,
                                code:result.responseDetail.code,
                                gender:result.responseDetail.gender,
                                dateOfBirth:result.responseDetail.dateOfBirth,
                                residenceAddress:result.responseDetail.residenceAddress,
                                correspondenceAddress:result.responseDetail.correspondenceAddress,
                                plans:result.responseDetail.plans
                            }
                            console.log(result.responseDetail)
                        })
                        this.updateCustomerFlag = true;
                        break;
                    default :
                        this.currentUser = Object.assign({},item);
                        this.updateFlag = true;
                        break;
                }

            },
            onApproval(id){
                let url = process.env.VUE_APP_API_BASEURL + '/api/user/'+ id +'/approve?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.approved'),
                            icon: 'done',
                            color:'success',
                            position:'top-center',
                            time: 3000
                        });
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onUpdateUser(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/user/' + this.currentUser._id + '?access_token=' + this.token;
                const {username, password, name, phone, email, agentNumber} = this.currentUser;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username,
                        password,
                        name,
                        phone,
                        email,
                        agentNumber,
                    })
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.updateFlag = false;
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            uploadDocs(e){
                this.uploading = true;
                let file = e.target.files[0];
                let formData = new FormData();
                formData.append("file", file);
                let url = process.env.VUE_APP_API_BASEURL + '/api/attachment/upload?access_token=' + this.token;
                fetch(url, {
                    method: 'POST',
                    body: formData
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    this.newPlan.quarterlyFundOverview = result.responseDetail._id;
                    if(result){
                        this.uploading = false;
                    }
                });
            },
            addPlan(){
                this.addPlanFlag = false;
                this.customer.plans.push(this.newPlan);
            },
            onUpdateCustomer(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/customer/' + this.customer._id +'?access_token=' + this.token;
                const {agent, username, code, name, phone, email, gender, dateOfBirth, residenceAddress, correspondenceAddress, plans} = this.customer;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        agent,
                        username,
                        password:'',
                        code,
                        name,
                        phone,
                        email,
                        gender,
                        dateOfBirth,
                        residenceAddress,
                        correspondenceAddress,
                        plans
                    })
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.updateCustomerFlag = false;
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onDeleteUser(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/user/delete/' + this.currentUser._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.updateFlag = false;
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorDel'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onDeleteCustomer(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/customer//delete/' + this.customer._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.updateCustomerFlag = false;
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorDel'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
        },
        components: {
            Datepicker,
            EditPlan,
        },
    }
</script>
<style>
    .scrollTable .vs-table--content{
        width: 1000px;
    }
</style>
<style scoped>
    @import '../../assets/css/alert.css';
    .tags{
        background: #f3ca8e;
        padding: 5px 10px;
        border-radius: 5px;
        font-size: 10px;
    }

    .Bg1{
        background: #2569C1;
        color: white;
    }
    .Bg2{
        background: #77ccf6;
        color: white;
    }
    .Bg3{
        background: #4f88f8;
        color: white;
    }
    .Bg4{
        background: #b9cffd;
        color: white;
    }

</style>
